window.showCustomToast = function (message, type = 'success') {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: type
  })

  Toast.fire({
    title: message
  })
}

window.deleteItem = function (deleteRoute, redirectRoute) {
  Swal.fire({
    title: 'Está seguro?',
    text: 'Esta acción es irreversible!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, eliminar!',
    cancelButtonText: 'No'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .delete(deleteRoute)
        .then(function (response) {
          Swal.fire('Eliminado!', 'Ha sido eliminado correctamente.', 'success').then(() => {
            window.location.href = redirectRoute
          })
        })
        .catch(function (error) {
          const errorMessage = error.response?.data?.message || 'Algo ha ido mal. Por favor, inténtelo de nuevo'
          Swal.fire('Error', errorMessage, 'error')

          console.error(error)
        })
    }
  })
}

window.inactiveItem = function (inactiveRoute, redirectRoute, isActive, title) {
  let actionText = isActive ? 'inactivar' : 'activar'
  const titleText = isActive ? `Inactivación de ${title}` : `Activación de ${title}`
  const resultText = `El ${title} ha sido ${isActive ? 'inactivado' : 'activado'} correctamente`

  Swal.fire({
    title: titleText,
    html:
      `<div class="mb-3"><label class="form-label">Motivo para ${actionText} el ${title} <span class="text-danger">(*)</span></label>` +
      `<textarea id="reason_modal" class="form-control" rows="3" placeholder="Ingrese el motivo para ${actionText}..."></textarea></div>`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: isActive ? '#d33' : '#28a745',
    cancelButtonColor: '#6c757d',
    confirmButtonText: `Sí, ${actionText}!`,
    cancelButtonText: 'Cancelar',
    preConfirm: () => {
      const reason = document.getElementById('reason_modal').value
      if (!reason || reason.trim() === '') {
        Swal.showValidationMessage('Debe ingresar un motivo')
        return false
      }
      return reason
    }
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .post(inactiveRoute, {
          reason_inactivation: result.value,
          active: !isActive
        })
        .then(function (response) {
          Swal.fire(`${actionText.charAt(0).toUpperCase() + actionText.slice(1, -1)}do!`, resultText, 'success').then(
            () => {
              window.location.href = redirectRoute
            }
          )
        })
        .catch(function (error) {
          Swal.fire('Uy!', 'Algo ha ido mal. Por favor, inténtelo de nuevo', 'error')
          console.error(error)
        })
    }
  })
}

window.forcePasswordChange = function (forceRoute, redirectRoute) {
  Swal.fire({
    title: 'Forzar cambio de contraseña',
    text: '¿Estás seguro que deseas forzar al cliente a cambiar su contraseña?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, forzar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .post(forceRoute)
        .then(function () {
          Swal.fire('¡Listo!', 'El cliente deberá cambiar su contraseña al iniciar sesión.', 'success').then(() => {
            window.location.href = redirectRoute
          })
        })
        .catch(function (error) {
          Swal.fire('Uy!', 'Ocurrió un error al forzar el cambio de contraseña.', 'error')
          console.error(error)
        })
    }
  })
}

window.resetPassword = function (resetRoute, redirectRoute) {
  Swal.fire({
    title: 'Resetear contraseña',
    text: 'Se cambiará la contraseña del usuario por su número de DNI. ¿Estás seguro?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, resetear',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .post(resetRoute)
        .then(function (response) {
          Swal.fire('¡Listo!', response.data.message, 'success').then(() => {
            window.location.href = redirectRoute
          })
        })
        .catch(function (error) {
          const errorMessage = error.response?.data?.message || 'Ocurrió un error al resetear la contraseña.'
          Swal.fire('Uy!', errorMessage, 'error')
          console.error(error)
        })
    }
  })
}

function validateTwoDigitDecimalNumber(event) {
  const regex = /^[+-]?\d*\.?\d{0,2}$/g
  const specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete']

  if (specialKeys.indexOf(event.key) !== -1) {
    return
  }

  const current = event.target.value
  const position = event.target.selectionStart
  const next = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('')

  if (next && !String(next).match(regex)) {
    event.preventDefault()
  }
}

;(function () {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('nuevo')) return
  params.delete('nuevo')
  const query = params.toString()
  window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash)
  window.addEventListener('load', () => {
    setTimeout(() => document.querySelector('[data-shortcut-new]')?.click(), 150)
  })
})()

document.addEventListener('input', function (event) {
  const input = event.target
  if (!input.matches || !input.matches('[data-coordinate]')) {
    return
  }

  let value = input.value.replace(',', '.').replace(/[^0-9.-]/g, '')
  const negative = value.startsWith('-')
  value = value.replace(/-/g, '')
  const [integer, ...decimals] = value.split('.')
  value = (negative ? '-' : '') + integer + (decimals.length ? '.' + decimals.join('') : '')

  if (value !== input.value) {
    input.value = value
  }
})
